import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService {

  constructor() { }
  getFilterEmpty(userFilters){
    return Object.keys(userFilters).length !== 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/utility.service.ts